module.exports = __webpack_public_path__ + "static/restoshop-f88eb1c1e22090f34394721954329442.png";